import { formatCmsResponse } from '../../../utils/cms';

const cmsPageLogic = async ({ pages }) => {
  let pageProps = {};
  // TODO: the basic logic here exists on /index and /[cms] pages as well
  // can be refactored to be used in all places (subtle differences,
  // but page/content logic the same)

  const pageData = formatCmsResponse(pages);

  if (pageData.code === 'ok') {
    pageProps = { ...pageProps, page: pageData.data, code: pageData.code };
    const activeContents = pageData.data.contents.filter((content) => content.publishedAt);
    const currentDateTime = Date.now();
    const pagePublishDateTime = Date.parse(pageData.data.publish_date);

    if (!pageData.data.publishedAt || activeContents.length === 0 || pagePublishDateTime > currentDateTime) {
      return {
        notFound: true
      };
    }

    const contentData = formatCmsResponse([activeContents[0]]);
    const contentPublishDateTime = Date.parse(contentData.data.publish_date);

    if (contentData.code === 'error') {
      return {
        notFound: true
      };
    }

    if (contentData.code === 'ok' && contentPublishDateTime < currentDateTime) {
      const { modules } = contentData.data;
      if (modules?.length > 0) {
        pageProps = { ...pageProps, modules };
        // eslint-disable-next-line no-underscore-dangle
        const [leScoopMod] = modules.filter?.((mod) => mod.__component === 'modules.le-scoop');
        const leScoopElements = leScoopMod?.elements;
        const featuredStoriesIds = leScoopElements?.map((story) => story.story_id);
        if (featuredStoriesIds?.length > 0) pageProps = { ...pageProps, featuredStoriesIds };
      }
    } else {
      return {
        notFound: true
      };
    }
  }

  if (pageData.code === 'error') {
    pageProps = { ...pageData };
  }

  // this logic does not handle errors coming from the fetching/formatting of the page data.
  // this is handled later in the process in /organisms/algolia-cms after we check if the category
  // is an active, untagged article.
  return pageProps;
};

export default cmsPageLogic;
